<!-- <xpo-shell [drawerClosedByDefault]="true">
  <xpo-header-app-name>Edge</xpo-header-app-name>
  <xpo-header-sub-app-name>Template</xpo-header-sub-app-name>
  <xpo-header-navigation>
    <button routerLink="main" routerLinkActive="xpo-selected">Main</button>
  </xpo-header-navigation>
  <xpo-header-actions>
    <xpo-auth-user-profile></xpo-auth-user-profile>
  </xpo-header-actions>
  <div class="root-container">
    <div class="root-container-main"> -->
      <router-outlet></router-outlet>
    <!-- </div>
    <xpo-footer xpoFooterSticky [version]="build"></xpo-footer>
  </div>
</xpo-shell>
 -->
